export class PartyIdType {
  constructor(code, name) {
    this.code = code
    this.name = name
  }
}

export const CODE_NAME = 'PartyIdType'

export const TYPENULL = new PartyIdType('', '')
export const EI = new PartyIdType('EI', 'EI')
export const ANI = new PartyIdType('ANI', 'ANI')
export const CIN = new PartyIdType('CIN', 'CIN')
export const TYPE34 = new PartyIdType('34', '34')
export const DUN = new PartyIdType('DUN', 'DUN')
export const DNS = new PartyIdType('DNS', 'DNS')
export const FR = new PartyIdType('FR', 'FR')
export const AEF = new PartyIdType('AEF', 'AEF')
export const TYPE2 = new PartyIdType('2', '2')
export const ZZ = new PartyIdType('ZZ', 'ZZ')
export const Party_Id_Types = [EI, ANI, CIN, TYPE34, DUN, DNS, FR, AEF, TYPE2, ZZ]

